import { useCallback } from 'react';

import { createContext, useContext, useState, ReactNode } from 'react';

interface CountdownContextType {
    targetTime: Date | null;
    setCountDown: (serverTime: string, targetTime: string) => void;
}

const CountdownContext = createContext<CountdownContextType | undefined>(undefined);

export function CountdownContextProvider({ children }: { children: ReactNode }) {
    const [targetTime, setTargetTime] = useState<Date | null>(null);

    const setCountDown = useCallback((serverTime: string, targetTime: string) => {
        // using the local time vs server time, calculate the diff that we apply on the target time
        const localTime = new Date();
        const serverTimeDate = new Date(serverTime);
        const timeDiff = serverTimeDate.getTime() - localTime.getTime();
        const timeTarget = new Date(targetTime);
        setTargetTime(new Date(timeTarget.getTime() + timeDiff));
    }, []);

    return (
        <CountdownContext.Provider value={{ targetTime, setCountDown }}>
            {children}
        </CountdownContext.Provider>
    );
}

/**
 * Countdown hook to access server time and target time.
 * @returns { targetTime: Date | null, setCountDown: (serverTime: string, targetTime: string) => void }
 * @throws {Error} if used outside of CountdownContextProvider
 */
export function useCountdown(): CountdownContextType {
    const context = useContext(CountdownContext);
    if (!context) {
        throw new Error('useCountdown must be used within a CountdownContextProvider');
    }
    return context;
}
